import { getAuthToken } from "../model/Benutzer";

const sendJSONexpectX = (method, where, object, X) => (
	fetch(where, {
		method,
		headers: {
			"Accept": X,
			"Content-Type": "application/json",
			"Authorization": "Bearer " + getAuthToken()
		},
		body: JSON.stringify(object)
	})
);

export const postJSONexpectText = (where, object) => (
	sendJSONexpectX("POST", where, object, "text/html")
);

export const putJSONexpectText = (where, object) => (
	sendJSONexpectX("PUT", where, object, "text/html")
);

export const postJSONexpectJSON = (where, object) => (
	sendJSONexpectX("POST", where, object, "application/json")
);

export const getPathexpectCSV = (where) => (
	fetch(where, {
		method: "GET",
		headers: {
			"Accept": "text/comma-separated-values",
			"Authorization": "Bearer " + getAuthToken()
		}
	})
);

